"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ParamParsers_1 = require("../../core/utils/ParamParsers");

var SuppliedProductOverviewFilter_1 = require("../model/SuppliedProductOverviewFilter");

var SuppliedProductOverviewFilterConverter_1 = require("./SuppliedProductOverviewFilterConverter");
/**
 * @author Radek Beran
 */


var SuppliedProductOverviewFilterConverterImpl =
/*#__PURE__*/
function (_SuppliedProductOverv) {
  _inherits(SuppliedProductOverviewFilterConverterImpl, _SuppliedProductOverv);

  function SuppliedProductOverviewFilterConverterImpl() {
    _classCallCheck(this, SuppliedProductOverviewFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProductOverviewFilterConverterImpl).apply(this, arguments));
  }

  _createClass(SuppliedProductOverviewFilterConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SuppliedProductOverviewFilter_1.SuppliedProductOverviewFilter(utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'cmCategoryId')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'cmCategoryIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'categoryPlanId')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'categoryPlanIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'supplierId')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'supplierIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'excludedProductIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'phraseForSearch')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'textForSearch')));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        cmCategoryId: source.cmCategoryId,
        cmCategoryIds: conversions.asObjectArray(source, 'cmCategoryIds', function (s) {
          return s;
        }),
        categoryPlanId: source.categoryPlanId,
        categoryPlanIds: conversions.asObjectArray(source, 'categoryPlanIds', function (s) {
          return s;
        }),
        supplierId: source.supplierId,
        supplierIds: conversions.asObjectArray(source, 'supplierIds', function (s) {
          return s;
        }),
        excludedProductIds: conversions.asObjectArray(source, 'excludedProductIds', function (s) {
          return s;
        }),
        phraseForSearch: source.phraseForSearch,
        textForSearch: source.textForSearch
      });
      return result;
    }
  }]);

  return SuppliedProductOverviewFilterConverterImpl;
}(SuppliedProductOverviewFilterConverter_1.SuppliedProductOverviewFilterConverter);

exports.SuppliedProductOverviewFilterConverterImpl = SuppliedProductOverviewFilterConverterImpl;